module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUgNC40N0w4Ljk3Ny40OTJsLjUzLjUzTDUuNTMgNWwzLjk3OCAzLjk3Ny0uNTMuNTNMNSA1LjUzIDEuMDIzIDkuNTA4bC0uNTMtLjUzTDQuNDcgNSAuNDkyIDEuMDIzbC41My0uNTNMNSA0LjQ3eiIgZmlsbD0iIzk5OSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/engine-clear.svg
// module id = 866
// module chunks = 0